import { Button, Card } from '@heroui/react'
import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { useAppStore, isApplicationLocked } from '@/store'

export default function StepsIndex() {
	const nav = useNavigate()
	const { user } = useAppStore()
	const isSubmitted = isApplicationLocked(user?.application_process)

	return (
		<div className="space-y-8 font-light">
			<header className="space-y-4">
				<h2 className="text-center text-3xl leading-6 font-light font-semibold">
					Welcome to your application!
				</h2>
			</header>
			<div className="flex flex-col gap-8">
				<p>
					You are applying for the <span className="font-semibold underline">Summer of 2027</span>.
					You're taking the first step into a life-changing journey. Congratulations!
				</p>
				<p>
					Completing and submitting your application may take 10 to 30 minutes. Your answers will be
					saved automatically every 30 seconds.
				</p>
				<p>
					Once submitted, our Admissions Officer will update you within 10 to 20 days. Check your
					Promotions, Social, and Spam folders regularly and mark our emails as safe so you don't
					miss any updates regarding your application. We will try to contact you via SMS as well.
				</p>
				<p>
					Want to see what a strong application looks like?{' '}
					<a
						href="https://www.leangap.org/articles/guide-getting-accepted-leangap"
						target="_blank"
						rel="noreferrer"
						className="text-primary-500 hover:text-primary-600 font-semibold hover:underline"
					>
						Read our guide to getting accepted
					</a>
					.
				</p>
			</div>

			<Card shadow="sm" className="overflow-hidden rounded-xl border-2 border-red-500 bg-red-950">
				<div className="flex items-center gap-2 bg-red-600 px-6 py-3 text-white">
					<span className="text-xl">⚠️</span>
					<span className="font-bold">Zero Tolerance for AI-Generated Content</span>
				</div>
				<div className="space-y-3 px-6 py-4 text-red-100">
					<p className="font-semibold">
						We have rejected applicants in the past for using AI tools like ChatGPT, Gemini, or
						Claude, even when used only to paraphrase, translate, or polish their answers.
					</p>
					<p>
						<span className="font-bold underline">Do not use AI in any form.</span> We use detection
						tools and manual review to identify AI-assisted content. If detected, your application
						will be{' '}
						<span className="font-bold underline">automatically rejected without appeal</span>.
					</p>
					<p>Write your answers yourself. We want to hear your authentic voice and story.</p>
				</div>
			</Card>

			<div>
				<Button
					color="primary"
					// size='md'
					onPress={() => nav('/account/steps/general')}
					endContent={<ArrowRight className="size-4" />}
				>
					{isSubmitted ? 'See' : 'Start'} your application
				</Button>
			</div>
		</div>
	)
}
